// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"899":"80210561","985":"7aa741e5","2632":"20e772fb","5656":"20e772fb","6205":"20e772fb","6645":"92be4368","8055":"f64cf9f8","8696":"391b4f14"}[chunkId] + ".chunk.css";
};